import CreateDonationModel from "./CreateDonationModel";
export default CreateDonationModel;
